import { useState, useEffect } from "react";
import { db } from "../../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import {
    addPartner,
    deletePartnerWithTransactions,
    updatePartner
} from "../../services/Entry/partnerService";
import { refreshUserTransactions } from "../../utils/refreshUser";
export const usePartners = (userId, showToast) => {
    const [partners, setPartners] = useState([]);
    const [isAddingPartner, setIsAddingPartner] = useState(false);
    const [isDeletingPartner, setIsDeletingPartner] = useState(false);
    const [isEditingPartner, setIsEditingPartner] = useState(false);

    const fetchPartners = async () => {
        if (!userId) return;

        const snapshot = await getDocs(
            collection(db, "users", userId, "partners")
        );

        const list = snapshot.docs.map(doc => {
            const data = doc.data();
            const myShare = Number(data.myShare ?? 0);

            return {
                id: doc.id,
                name: data.name,
                myShare,
                partnerShare: 100 - myShare // ✅ derived
            };
        });

        setPartners(list);
    };

    const createPartner = async (name, myShare) => {
        if (!name) {
            showToast("Enter partner name", "warning");
            return;
        }

        if (myShare < 0 || myShare > 100) {
            showToast("Enter valid % (0-100)", "warning");
            return;
        }

        try {
            setIsAddingPartner(true);
            await addPartner(userId, { name, myShare: Number(myShare) });
            await refreshUserTransactions(userId);
            await fetchPartners();
            showToast("Partner added!", "success");
        } catch (err) {
            showToast("Failed to add partner", "error");
        } finally {
            setIsAddingPartner(false);
        }
    };

    const removePartner = async (partnerId) => {
        try {
            setIsDeletingPartner(true);
            await deletePartnerWithTransactions(userId, partnerId);
            await refreshUserTransactions(userId);
            await fetchPartners();
            showToast("Partner deleted", "success");
        } catch (err) {
            showToast("Delete failed", "error");
        } finally {
            setIsDeletingPartner(false);
        }
    };

    const editPartner = async (partnerId, updatedFields) => {
        const { name, myShare } = updatedFields;

        if (!name) {
            showToast("Name cannot be empty", "warning");
            return;
        }

        if (myShare < 0 || myShare > 100) {
            showToast("Enter valid % (0-100)", "warning");
            return;
        }

        try {
            setIsEditingPartner(true);
            await updatePartner(userId, partnerId, {
                name,
                myShare: Number(myShare)
            });
            await refreshUserTransactions(userId);

            await fetchPartners();
            showToast("Partner updated", "success");
        } catch (err) {
            showToast("Update failed", "error");
        } finally {
            setIsEditingPartner(false);
        }
    };

    useEffect(() => {
        fetchPartners();
    }, [userId]);

    return { partners, createPartner, removePartner, editPartner, isAddingPartner, isDeletingPartner, isEditingPartner };
};